import { NAV } from "../components/shared";

export function usePermissions(userRole) {
  const r = userRole;
  const isAdmin      = r === "admin";
  const hasPayments  = isAdmin || r === "manager" || r === "payments" || r === "full_access";
  const hasMaint     = isAdmin || r === "manager" || r === "maintenance" || r === "full_access";
  const hasTenants   = isAdmin || r === "manager" || r === "tenants" || r === "full_access";

  const can = {
    addTenant:      hasTenants,
    editTenant:     hasTenants,
    deleteTenant:   isAdmin,
    addPayment:     hasPayments,
    editPayment:    hasPayments,
    deletePayment:  isAdmin,
    genPayments:    hasPayments,
    addMaint:       hasMaint,
    editMaint:      true,
    deleteMaint:    isAdmin,
    viewFinancials: hasPayments,
    editExpense:    isAdmin,
    viewSettings:   isAdmin,
    manageTeam:     isAdmin,
    addComm:        true,
    deleteComm:     hasPayments,
  };

  const visibleNav = isAdmin
    ? [...NAV, "Communications", "Team"]
    : r === "manager" || r === "full_access"
      ? ["Dashboard", "Tenants", "Properties", "Payments", "Maintenance", "Financials", "Documents", "Communications"]
      : r === "payments"
        ? ["Dashboard", "Payments", "Tenants", "Properties"]
        : r === "maintenance"
          ? ["Dashboard", "Maintenance", "Tenants", "Properties"]
          : r === "tenants"
            ? ["Dashboard", "Tenants", "Properties", "Maintenance"]
            : r === "view_only"
              ? ["Dashboard", "Tenants", "Properties", "Maintenance"]
              : ["Dashboard", "Tenants", "Properties", "Maintenance", "Documents"]; // employee/default

  return { can, visibleNav };
}
